// AUTO-GENERATED by scripts/merge-board-content.mjs from _mock/_gen_board/*.json.
// Do not edit by hand — regenerate instead.

export const boardByDoor = {};

export const boardByMission = {
  "m-mnt1": {
    "prefix": "OPS",
    "tickets": [
      {
        "title": "Triage entrant + routage SLA P1",
        "description": "Classer chaque ticket entrant par sévérité et router les P1 vers l'on-call sous 15 min.",
        "status": "done",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Iris (Support Triage)",
        "labels": [
          "ops",
          "support"
        ],
        "dependsOn": []
      },
      {
        "title": "Alerte SLA P1 4h sur incident critique",
        "description": "Déclencher une page on-call si un P1 dépasse 50% du budget SLA (2h) sans accusé.",
        "status": "in_progress",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Théo (On-call Engineer)",
        "labels": [
          "ops",
          "infra"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Hotfix timeout auth Life Connect",
        "description": "Patcher le timeout des sessions auth qui sature le pool de connexions en heure de pointe.",
        "status": "in_review",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Théo (On-call Engineer)",
        "labels": [
          "backend",
          "ops"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Automatiser la purge des logs",
        "description": "Cron de rétention 30j sur R2 + D1 avec idempotency pour éviter les double-suppressions.",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Nora (Automation Engineer)",
        "labels": [
          "infra",
          "automation"
        ],
        "dependsOn": []
      },
      {
        "title": "Renouvellement automatique des certs TLS",
        "description": "Workflow de renouvellement 30j avant expiration avec rollback si la chaîne échoue.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Nora (Automation Engineer)",
        "labels": [
          "infra",
          "security"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Runbook escalade on-call",
        "description": "Documenter la procédure d'escalade P1/P2 et les contacts de garde par rotation.",
        "status": "done",
        "priority": "low",
        "phase": "Discovery",
        "assignee": "Sacha (Ops Lead)",
        "labels": [
          "docs",
          "ops"
        ],
        "dependsOn": [
          1,
          2
        ]
      },
      {
        "title": "Revue sécurité du cron de purge",
        "description": "Auditer les permissions IAM du job de purge pour éviter une suppression hors-scope.",
        "status": "backlog",
        "priority": "high",
        "phase": "Review",
        "assignee": "Boris (Security Reviewer)",
        "labels": [
          "security",
          "qa"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Dashboard santé SLA + run continu",
        "description": "Exposer un board temps réel du taux de respect SLA et du backlog de tickets ouverts.",
        "status": "planned",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Sacha (Ops Lead)",
        "labels": [
          "ops",
          "data"
        ],
        "dependsOn": [
          2,
          3
        ]
      }
    ]
  },
  "m-p1": {
    "prefix": "CHU",
    "tickets": [
      {
        "title": "Audit des points de churn par cohorte",
        "description": "Analyser les annulations des 12 derniers mois pour isoler les moments de décrochage par cohorte d'inscription.",
        "status": "backlog",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Nora (Data Analyst)",
        "labels": [
          "data",
          "research"
        ],
        "dependsOn": []
      },
      {
        "title": "Interviews clients churned + à risque",
        "description": "Mener 8 entretiens (clients partis + comptes à faible usage) pour qualifier les causes réelles d'abandon.",
        "status": "backlog",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Robin (Retention Lead)",
        "labels": [
          "research",
          "ops"
        ],
        "dependsOn": []
      },
      {
        "title": "Définir le health score et le seuil at-risk",
        "description": "Spécifier le scoring d'activation et le seuil déclenchant les relances, à partir de l'audit cohortes.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Nora (Data Analyst)",
        "labels": [
          "data"
        ],
        "dependsOn": [
          1,
          2
        ]
      },
      {
        "title": "Refonte du parcours d'onboarding",
        "description": "Redécouper l'onboarding en étapes jalonnées pour atteindre la première valeur en moins de 7 jours.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Léa (Lifecycle Marketer)",
        "labels": [
          "marketing",
          "design"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Schéma événements lifecycle + webhook",
        "description": "Définir les events produit (signup, activation, usage drop) et le webhook alimentant le moteur de relances.",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Sam (Backend Engineer)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          3
        ]
      },
      {
        "title": "Séquence de relances pré-renouvellement",
        "description": "Maquetter la séquence multi-touch J-30/J-14/J-3 avant renouvellement avec branches selon le health score.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Léa (Lifecycle Marketer)",
        "labels": [
          "marketing"
        ],
        "dependsOn": [
          3,
          5
        ]
      },
      {
        "title": "Setup deliverability SPF/DKIM/DMARC",
        "description": "Configurer l'authentification et le warm-up du domaine d'envoi pour garantir un taux de délivrabilité fiable.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Théo (Deliverability Specialist)",
        "labels": [
          "infra",
          "ops"
        ],
        "dependsOn": [
          6
        ]
      },
      {
        "title": "Campagne win-back clients partis",
        "description": "Concevoir l'offre et la séquence win-back ciblant les comptes annulés sur les 90 derniers jours.",
        "status": "backlog",
        "priority": "low",
        "phase": "Planning",
        "assignee": "Robin (Retention Lead)",
        "labels": [
          "marketing"
        ],
        "dependsOn": [
          1,
          6
        ]
      },
      {
        "title": "Plan de mesure d'impact par cohorte",
        "description": "Définir l'A/B test et le dashboard de suivi du churn par cohorte pour prouver la baisse de 20 %.",
        "status": "planned",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Nora (Data Analyst)",
        "labels": [
          "data",
          "qa"
        ],
        "dependsOn": [
          3,
          6,
          8
        ]
      }
    ]
  },
  "m-p2": {
    "prefix": "PRC",
    "tickets": [
      {
        "title": "Cartographier les clients existants par plan actuel",
        "description": "Extraire la base clients et segmenter par usage/MRR pour dimensionner le grandfathering.",
        "status": "backlog",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Bruno (Delivery Lead)",
        "labels": [
          "data",
          "ops"
        ],
        "dependsOn": []
      },
      {
        "title": "Definir les 3 paliers et regles de pricing v2",
        "description": "Fixer features, limites et prix des 3 paliers, valides contre la marge cible.",
        "status": "backlog",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Sofia (Pricing Engineer)",
        "labels": [
          "data",
          "backend"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Politique de grandfathering anti-churn",
        "description": "Specifier quels clients gardent l'ancien tarif et la duree de gel avant migration.",
        "status": "planned",
        "priority": "urgent",
        "phase": "Planning",
        "assignee": "Sofia (Pricing Engineer)",
        "labels": [
          "data",
          "ops"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Plan de migration des abonnements en backfill",
        "description": "Decouper le backfill des souscriptions en vagues avec rollback et idempotency par client.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Karim (Billing Reviewer)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          3
        ]
      },
      {
        "title": "Maquette de la page pricing 3 paliers",
        "description": "Concevoir le layout responsive des 3 paliers avec toggle mensuel/annuel et CTA.",
        "status": "planned",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Igor (Frontend Engineer)",
        "labels": [
          "design",
          "frontend"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Setup A/B test sur la page pricing",
        "description": "Cadrer la repartition trafic et les metriques de conversion pour comparer v1 vs v2.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Igor (Frontend Engineer)",
        "labels": [
          "frontend",
          "qa"
        ],
        "dependsOn": [
          5
        ]
      },
      {
        "title": "Sequence d'emails de communication tarifaire",
        "description": "Rediger la sequence d'annonce expliquant le grandfathering pour limiter le churn.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Léa (Lifecycle Marketer)",
        "labels": [
          "marketing",
          "docs"
        ],
        "dependsOn": [
          3
        ]
      },
      {
        "title": "Revue conformite facturation de la migration",
        "description": "Verifier prorata, TVA et SLA de facturation avant d'autoriser le backfill en prod.",
        "status": "backlog",
        "priority": "high",
        "phase": "Review",
        "assignee": "Karim (Billing Reviewer)",
        "labels": [
          "backend",
          "security"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Checklist go-live et criteres de churn acceptables",
        "description": "Definir le seuil de churn tolere et les conditions de rollback du lancement v2.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Bruno (Delivery Lead)",
        "labels": [
          "ops",
          "qa"
        ],
        "dependsOn": [
          6,
          7,
          8
        ]
      }
    ]
  },
  "m-p3": {
    "prefix": "AUD",
    "tickets": [
      {
        "title": "Cadrage périmètre audit Life Connect",
        "description": "Lister les composants in-scope (API, admin, stockage logs, gestion clés) et figer les critères go/no-go.",
        "status": "backlog",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Sven (Audit Lead)",
        "labels": [
          "security",
          "docs"
        ],
        "dependsOn": []
      },
      {
        "title": "Collecte des accès et inventaire des assets",
        "description": "Récupérer accès read-only infra/repo et dresser l'inventaire des services, buckets et secrets.",
        "status": "backlog",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Rafael (Findings Triager)",
        "labels": [
          "ops",
          "infra"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "BLOQUANT — Logs admin non chiffrés au repos",
        "description": "Documenter l'absence de chiffrement at-rest des logs admin et qualifier l'exposition des données sensibles.",
        "status": "planned",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Sonia (Security Auditor)",
        "labels": [
          "security",
          "data"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "BLOQUANT — Pas de rotation des clés API",
        "description": "Constater l'absence de rotation/expiry des clés API et évaluer le blast-radius d'une fuite de clé.",
        "status": "planned",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Sonia (Security Auditor)",
        "labels": [
          "security",
          "backend"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Revue archi — recherche de SPOF",
        "description": "Cartographier les dépendances et confirmer l'absence de SPOF critique sur le chemin nominal.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Aïcha (Architecture Reviewer)",
        "labels": [
          "infra",
          "ops"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Importants — durcissement IAM et secrets",
        "description": "Relever les 4 findings importants (IAM trop large, secrets en clair, TLS, headers) avec remédiation.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Sonia (Security Auditor)",
        "labels": [
          "security",
          "backend"
        ],
        "dependsOn": [
          3,
          4
        ]
      },
      {
        "title": "Triage et scoring des findings",
        "description": "Consolider tous les findings, scorer par sévérité/effort et trancher bloquant vs important.",
        "status": "planned",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Rafael (Findings Triager)",
        "labels": [
          "security",
          "qa"
        ],
        "dependsOn": [
          3,
          4,
          5,
          6
        ]
      },
      {
        "title": "Rapport d'audit + décision go/no-go",
        "description": "Rédiger le rapport final et statuer no-go déploiement tant que les 2 bloquants ne sont pas levés.",
        "status": "backlog",
        "priority": "urgent",
        "phase": "Review",
        "assignee": "Sven (Audit Lead)",
        "labels": [
          "docs",
          "security"
        ],
        "dependsOn": [
          7
        ]
      }
    ]
  },
  "m-p4": {
    "prefix": "CRO",
    "tickets": [
      {
        "title": "Audit du funnel checkout NC Cosmetic",
        "description": "Cartographier les 7 champs actuels et localiser les drop-offs étape par étape.",
        "status": "planned",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Olivia (CRO Optimizer)",
        "labels": [
          "marketing",
          "data"
        ],
        "dependsOn": []
      },
      {
        "title": "Re-mesure de la baseline de conversion",
        "description": "Confirmer le taux baseline 3,4 % sur 30 jours de trafic avant toute modification.",
        "status": "planned",
        "priority": "urgent",
        "phase": "Discovery",
        "assignee": "Marc (Data Analyst)",
        "labels": [
          "data"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Calcul de la taille d'échantillon A/B",
        "description": "Déterminer le N requis pour détecter +0,5 pt à 95 % de significativité et 80 % de power.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Marc (Data Analyst)",
        "labels": [
          "data",
          "qa"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Spec variante checkout 7→4 champs",
        "description": "Définir les 3 champs à fusionner/supprimer et la logique d'auto-complétion adresse.",
        "status": "planned",
        "priority": "high",
        "phase": "Planning",
        "assignee": "Olivia (CRO Optimizer)",
        "labels": [
          "design",
          "marketing"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Implémenter la variante B du checkout",
        "description": "Coder le formulaire 4 champs derrière un flag, isofonctionnel sur paiement et validation.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Igor (Frontend Engineer)",
        "labels": [
          "frontend"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Instrumentation tracking A/B",
        "description": "Émettre les events expose/submit/success par bucket pour alimenter la mesure de significativité.",
        "status": "backlog",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Igor (Frontend Engineer)",
        "labels": [
          "frontend",
          "data"
        ],
        "dependsOn": [
          3,
          5
        ]
      },
      {
        "title": "Lancement et monitoring de l'A/B test",
        "description": "Démarrer le split 50/50 et surveiller le taux quotidien jusqu'à atteindre le N cible.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Marc (Data Analyst)",
        "labels": [
          "data",
          "ops"
        ],
        "dependsOn": [
          6
        ]
      },
      {
        "title": "Revue de significativité du résultat",
        "description": "Valider que l'uplift est statistiquement significatif avant de déclarer la variante gagnante.",
        "status": "backlog",
        "priority": "urgent",
        "phase": "Review",
        "assignee": "Rapha (CRO Reviewer)",
        "labels": [
          "qa",
          "data"
        ],
        "dependsOn": [
          7
        ]
      },
      {
        "title": "Priorisation du levier #2 post-mesure",
        "description": "Re-mesurer la baseline gagnante et shortlister le prochain levier d'optimisation.",
        "status": "backlog",
        "priority": "low",
        "phase": "Review",
        "assignee": "Olivia (CRO Optimizer)",
        "labels": [
          "marketing",
          "docs"
        ],
        "dependsOn": [
          8
        ]
      }
    ]
  },
  "m-v1": {
    "prefix": "DBM",
    "tickets": [
      {
        "title": "Audit du schema v2 + cartographie des lectures/ecritures",
        "description": "Recenser toutes les tables, requetes et chemins d'acces impactes par la migration v3 avant toute modif.",
        "status": "done",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Magnus (Migration Lead)",
        "labels": [
          "data",
          "docs"
        ],
        "dependsOn": []
      },
      {
        "title": "Design dual-write + plan de rollback",
        "description": "Specifier la strategie d'ecriture parallele v2/v3 et documenter le rollback step-by-step.",
        "status": "done",
        "priority": "urgent",
        "phase": "Planning",
        "assignee": "Magnus (Migration Lead)",
        "labels": [
          "data",
          "ops"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Implementer la couche dual-write idempotente",
        "description": "Ecrire simultanement v2 et v3 avec idempotency par cle metier ; aucun double effet en cas de retry.",
        "status": "in_progress",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Bjorn (Backend Engineer)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Job de backfill v2 vers v3 par batch",
        "description": "Migrer l'historique par batchs reprenables sans saturer la DB ni bloquer les ecritures live.",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Dimitri (Data Engineer)",
        "labels": [
          "data",
          "infra"
        ],
        "dependsOn": [
          3
        ]
      },
      {
        "title": "Verification par checksum v2/v3",
        "description": "Comparer les checksums par partition et lister tout drift entre source et cible.",
        "status": "in_review",
        "priority": "high",
        "phase": "Review",
        "assignee": "Dimitri (Data Engineer)",
        "labels": [
          "data",
          "qa"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Bascule progressive des lectures (feature flag %)",
        "description": "Router un pourcentage croissant des lectures vers v3 via flag, avec kill-switch immediat.",
        "status": "blocked",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Bjorn (Backend Engineer)",
        "labels": [
          "backend",
          "ops"
        ],
        "dependsOn": [
          5
        ]
      },
      {
        "title": "Dashboards SLA + alerting latence/erreurs",
        "description": "Instrumenter latence, taux d'erreur et lag de replication pour surveiller la bascule en temps reel.",
        "status": "planned",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Solveig (SRE Reviewer)",
        "labels": [
          "ops",
          "infra"
        ],
        "dependsOn": [
          6
        ]
      },
      {
        "title": "Test de rollback en staging",
        "description": "Rejouer un rollback complet v3 vers v2 sur staging et prouver zero perte de donnee.",
        "status": "planned",
        "priority": "high",
        "phase": "Review",
        "assignee": "Solveig (SRE Reviewer)",
        "labels": [
          "ops",
          "qa"
        ],
        "dependsOn": [
          2,
          6
        ]
      },
      {
        "title": "Runbook bascule finale + decommissioning v2",
        "description": "Rediger le runbook de cutover 100% v3 et le plan de retrait des chemins v2.",
        "status": "backlog",
        "priority": "low",
        "phase": "Review",
        "assignee": "Magnus (Migration Lead)",
        "labels": [
          "docs",
          "ops"
        ],
        "dependsOn": [
          7,
          8
        ]
      }
    ]
  },
  "m-v2": {
    "prefix": "STR",
    "tickets": [
      {
        "title": "Audit du flux paiements actuel",
        "description": "Cartographier les events Stripe reçus et les points où un paiement peut se perdre aujourd'hui.",
        "status": "done",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Boris (Backend Lead)",
        "labels": [
          "backend",
          "docs"
        ],
        "dependsOn": []
      },
      {
        "title": "Endpoint webhook + vérification de signature",
        "description": "Exposer /webhooks/stripe et rejeter tout payload non signé (400) avant tout traitement.",
        "status": "done",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Nadia (Backend Engineer)",
        "labels": [
          "backend",
          "security"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Idempotency store sur event_id",
        "description": "Persister les event_id traités pour qu'un doublon ne déclenche aucun second effet.",
        "status": "in_review",
        "priority": "urgent",
        "phase": "Implementation",
        "assignee": "Théo (Backend Engineer)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Retry avec backoff exponentiel",
        "description": "Replanifier les échecs transitoires, plafond 5 essais, puis bascule en dead-letter.",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Théo (Backend Engineer)",
        "labels": [
          "backend",
          "infra"
        ],
        "dependsOn": [
          3
        ]
      },
      {
        "title": "Dead-letter queue + alerting SLA",
        "description": "Router les events épuisés vers une DLQ et alerter si le backlog dépasse le SLA.",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Nadia (Backend Engineer)",
        "labels": [
          "backend",
          "ops"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Job de réconciliation paiements",
        "description": "Backfill quotidien comparant events Stripe vs base locale pour viser 0 paiement perdu.",
        "status": "planned",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Boris (Backend Lead)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          3,
          5
        ]
      },
      {
        "title": "Tests d'intégration rejeu d'events",
        "description": "Rejouer un dump d'events réels et prouver l'absence de double traitement et de perte.",
        "status": "planned",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Théo (Backend Engineer)",
        "labels": [
          "qa",
          "backend"
        ],
        "dependsOn": [
          4,
          6
        ]
      },
      {
        "title": "Revue sécurité signature + secrets",
        "description": "Auditer la rotation du signing secret et la résistance au replay sur l'endpoint webhook.",
        "status": "backlog",
        "priority": "high",
        "phase": "Review",
        "assignee": "Sofia (Security Reviewer)",
        "labels": [
          "security",
          "qa"
        ],
        "dependsOn": [
          2
        ]
      },
      {
        "title": "Runbook réconciliation + on-call",
        "description": "Documenter la procédure de rejeu manuel depuis la DLQ pour l'astreinte.",
        "status": "blocked",
        "priority": "low",
        "phase": "Review",
        "assignee": "Boris (Backend Lead)",
        "labels": [
          "docs",
          "ops"
        ],
        "dependsOn": [
          6
        ]
      }
    ]
  },
  "m-v3": {
    "prefix": "RTA",
    "tickets": [
      { "title": "Schéma d'événements + contrat d'ingestion", "description": "Définir le schéma typé des événements analytics et le endpoint d'ingestion idempotent.", "branch": "main", "status": "done", "priority": "urgent", "phase": "Planning", "assignee": "Rafa (Realtime Lead)", "labels": ["data", "backend"], "dependsOn": [] },
      { "title": "Pipeline d'ingestion + buffer en file", "description": "Recevoir les événements bruts et les pousser dans une Queue avec idempotency par event_id.", "branch": "main", "status": "done", "priority": "urgent", "phase": "Implementation", "assignee": "Bilal (Backend Engineer)", "labels": ["backend", "infra"], "dependsOn": [1] },

      { "title": "Agrégation serveur par fenêtres glissantes", "description": "Calculer les compteurs et métriques par tumbling window de 1 s côté Durable Object.", "branch": "agrégation", "status": "in_progress", "priority": "high", "phase": "Implementation", "assignee": "Bilal (Backend Engineer)", "labels": ["backend", "data"], "dependsOn": [2] },
      { "title": "Backfill historique au branchement client", "description": "Envoyer un snapshot des dernières fenêtres au client qui se connecte avant le flux live.", "branch": "agrégation", "status": "in_review", "priority": "medium", "phase": "Implementation", "assignee": "Sora (Streaming Engineer)", "labels": ["backend", "data"], "dependsOn": [3] },

      { "title": "Transport temps réel WS + fallback SSE", "description": "Diffuser les agrégats via WebSocket avec repli SSE — merge la branche agrégation.", "branch": "main", "status": "in_progress", "priority": "high", "phase": "Implementation", "assignee": "Sora (Streaming Engineer)", "labels": ["backend", "infra"], "dependsOn": [2, 4] },

      { "title": "Dashboard configurable (widgets)", "description": "L'écran dashboard — découpé en plusieurs tâches faites en parallèle (voir sous-tâches).", "branch": "main", "status": "planned", "priority": "high", "phase": "Implementation", "assignee": "Lena (Frontend Engineer)", "labels": ["frontend", "design"], "dependsOn": [5] },
      { "title": "Grille drag-and-drop", "description": "Tâche du dashboard : ajouter / redimensionner / réordonner les widgets.", "branch": "widgets", "parent": 6, "status": "planned", "priority": "high", "phase": "Implementation", "assignee": "Lena (Frontend Engineer)", "labels": ["frontend"], "dependsOn": [6] },
      { "title": "Persistance du layout par utilisateur", "description": "Tâche du dashboard : sauvegarder la disposition des widgets (dépend de la grille).", "branch": "widgets", "parent": 6, "status": "backlog", "priority": "medium", "phase": "Implementation", "assignee": "Lena (Frontend Engineer)", "labels": ["frontend"], "dependsOn": [7] },
      { "title": "Souscription WS résiliente (reconnexion)", "description": "Tâche du dashboard, EN PARALLÈLE de la grille : flux live + déduplication.", "branch": "souscription", "parent": 6, "status": "planned", "priority": "medium", "phase": "Implementation", "assignee": "Otto (Perf Reviewer)", "labels": ["frontend"], "dependsOn": [6] },

      { "title": "Métrologie latence p95 end-to-end < 2 s", "description": "Instrumenter ingestion→widget — merge les tâches du dashboard.", "branch": "main", "status": "blocked", "priority": "high", "phase": "Review", "assignee": "Otto (Perf Reviewer)", "labels": ["qa", "ops"], "dependsOn": [6, 8, 9] },
      { "title": "Load test 10k événements/s + dégradation gracieuse", "description": "Prouver la tenue à 10k evt/s et le drop contrôlé des fenêtres sous saturation.", "branch": "main", "status": "backlog", "priority": "medium", "phase": "Review", "assignee": "Otto (Perf Reviewer)", "labels": ["qa", "infra"], "dependsOn": [10] }
    ]
  },
  "m-v4": {
    "prefix": "VEI",
    "tickets": [
      {
        "title": "Cartographier les sources de veille cosmétique",
        "description": "Lister flux RSS, comptes sociaux et newsletters concurrents (clean beauty, sérums) à surveiller.",
        "status": "done",
        "priority": "high",
        "phase": "Discovery",
        "assignee": "Sasha (Market Scout Lead)",
        "labels": [
          "data",
          "ops"
        ],
        "dependsOn": []
      },
      {
        "title": "Définir le panel de concurrents prioritaires",
        "description": "Sélectionner les 12 marques clean beauty à tracker en continu et leur SOV cible.",
        "status": "done",
        "priority": "medium",
        "phase": "Planning",
        "assignee": "Cléo (Competitive Analyst)",
        "labels": [
          "data",
          "marketing"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Pipeline d'ingestion des sources + dédoublonnage",
        "description": "Collecter chaque source via webhook/cron et dédupliquer les items par hash de contenu.",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Sasha (Market Scout Lead)",
        "labels": [
          "backend",
          "data"
        ],
        "dependsOn": [
          1
        ]
      },
      {
        "title": "Tagger les lancements sérums clean des concurrents",
        "description": "Classer chaque item ingéré par catégorie produit (sérum, INCI clean) pour analyse tendance.",
        "status": "in_progress",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Cléo (Competitive Analyst)",
        "labels": [
          "data",
          "marketing"
        ],
        "dependsOn": [
          2,
          3
        ]
      },
      {
        "title": "Scoring tendance clean beauty / sérums",
        "description": "Calculer un indice de momentum par tendance à partir du volume et de la croissance hebdo.",
        "status": "in_progress",
        "priority": "medium",
        "phase": "Implementation",
        "assignee": "Tariq (Trend Researcher)",
        "labels": [
          "data"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Revue conformité claims clean beauty (UE)",
        "description": "Vérifier que les claims observés (clean, naturel) respectent le règlement cosmétique avant suggestion.",
        "status": "blocked",
        "priority": "urgent",
        "phase": "Review",
        "assignee": "Reza (Regulatory Reviewer)",
        "labels": [
          "docs",
          "qa"
        ],
        "dependsOn": [
          4
        ]
      },
      {
        "title": "Template digest hebdo + envoi automatisé",
        "description": "Composer le digest hebdomadaire (top mouvements + tendances) et l'envoyer chaque lundi 9h.",
        "status": "planned",
        "priority": "high",
        "phase": "Implementation",
        "assignee": "Tariq (Trend Researcher)",
        "labels": [
          "frontend",
          "ops"
        ],
        "dependsOn": [
          4,
          5
        ]
      },
      {
        "title": "Note de suggestion : ligne sérum clean Q3",
        "description": "Rédiger la reco produit ligne sérum clean Q3 appuyée sur les signaux de veille et le scoring.",
        "status": "backlog",
        "priority": "medium",
        "phase": "Review",
        "assignee": "Cléo (Competitive Analyst)",
        "labels": [
          "marketing",
          "docs"
        ],
        "dependsOn": [
          5,
          6,
          7
        ]
      },
      {
        "title": "Dashboard SOV concurrents temps réel",
        "description": "Exposer un tableau de bord part de voix par marque, rafraîchi à chaque cycle d'ingestion.",
        "status": "backlog",
        "priority": "low",
        "phase": "Implementation",
        "assignee": "Sasha (Market Scout Lead)",
        "labels": [
          "frontend",
          "data"
        ],
        "dependsOn": [
          3,
          5
        ]
      }
    ]
  }
};
